import React, { Component } from 'react';
import IconSearch from '../atoms/IconSearch';
import IconInfo from '../atoms/IconInfo';
import { Link } from 'react-router-dom';
import Logo from '../atoms/Logo';

class Nav extends Component {

  render() {
    return (
      <div className="Nav">
        <Link className="NavInfoButton" to="/info"><IconInfo/></Link>
        <Logo/>
        <Link className="NavSearchButton" to="/search"><IconSearch/></Link>
      </div>
    )
  }
}

export default Nav;